import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=615e678a&scoped=true"
import script from "./Authentication.vue?vue&type=script&lang=js"
export * from "./Authentication.vue?vue&type=script&lang=js"
import style1 from "./Authentication.vue?vue&type=style&index=1&id=615e678a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615e678a",
  null
  
)

export default component.exports